<header>
  <!-- Bar Logo -->
  <section class="container section-logo">
    <div class="row">
      <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-md-left">
        <a (click)="onClickMenu('inicio')"><img src="./assets/images/logo_NPB.png" class="img-fluid" title="Logo da Nota Premiada Bahia." alt="logo"></a>
      </div>
      <div class="col col-sm-6 col-md-6 col-lg-6 col-xl-6 text-sm-right text-md-right hidden-xs-down align-self-end">
        <img src="./assets/images/brasao_topo.png" width="248" class="img-fluid" title="Logo do Governo da Bahia." alt="Governo da Bahia">
      </div>
    </div>
  </section>
  <!-- /.Bar Logo -->

  <!-- Navbar -->
  <app-menu></app-menu>
  <!-- /.Navbar -->

</header>



// WEBPACK FOOTER //
// ./src/app/shared-layout/header/header.component.html